import Map, { MapGeolocation } from "components/Map";
import { FC, useEffect, useState } from "react";
import ConvoyStatusGuide from "./ConvoyStatusGuide";
import { Box, Skeleton, styled } from "@mui/material";
import { ConvoyLocation } from "api/ConvoyDashboardAPI";

const Container = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey["200"]}`,
  overflow: "hidden",
  display: "flex",
  height: 350
}));

interface ConvoyMapProps {
  zoom: number;
  isLoading: boolean;
  totalConvoys: number;
  convoyLocations: ConvoyLocation[];
}

const ConvoyMap: FC<ConvoyMapProps> = ({
  zoom,
  isLoading,
  totalConvoys,
  convoyLocations
}) => {
  const [geolocations, setGeolocations] = useState<MapGeolocation[]>([]);

  useEffect(() => {
    if (convoyLocations.length > 0) {
      const configGeographic: MapGeolocation[] = [];
      convoyLocations.forEach(location => {
        configGeographic.push({
          lat: Number(location.latitude),
          lng: Number(location.longitude),
          style: "circle"
        });
      });
      setGeolocations(configGeographic || []);
    } else {
      setGeolocations([]);
    }
  }, [convoyLocations]);

  return (
    <Container>
      <div
        style={{
          flexGrow: 1,
          width: "100%"
        }}
      >
        {isLoading && <Skeleton variant="rectangular" height={348} />}
        {!isLoading && (
          <Map
            zoom={zoom}
            customControls={<ConvoyStatusGuide total={totalConvoys} />}
            geolocations={geolocations}
          />
        )}
      </div>
    </Container>
  );
};

export default ConvoyMap;
